import React from 'react';
import './PC.css';
import Bodryk from '../../img/pc/Bodryk.png'
import Chen from '../../img/pc/Chen.png'
import Cholerton from '../../img/pc/Cholerton.png'
import Cyberlandsio from '../../img/pc/Cyberlandsio.png'
import Exabeam from '../../img/pc/Exabeam.png'
import Hunt from '../../img/pc/Hunt.png'
import Insecurity from '../../img/pc/Insecurity.png'
import Khariuk from '../../img/pc/Khariuk.png'
import Lohrmann from '../../img/pc/Lohrmann.png'
import Microsoft from '../../img/pc/Microsoft.png'
import Nwodo from '../../img/pc/Nwodo.png'
import Paypal from '../../img/pc/Paypal.png'
import Privasec from '../../img/pc/Privasec.png'
import Tan from '../../img/pc/Tan.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Chen,
          name: 'George Chen',
          position: 'Threat Management and IR Lead Engineer',
          ln: 'https://www.linkedin.com/in/spigeo/',
          logo: Paypal,
        },
        {
          photo: Lohrmann,
          name: 'Dan Lohrmann',
          position: 'Chief Security Officer & Chief Strategist',
          ln: 'https://www.linkedin.com/in/danlohrmann/',
          tw: 'https://twitter.com/govcso',
        },
        {
          photo: Nwodo,
          name: 'Adora Nwodo',
          position: 'Software Engineer',
          ln: 'https://www.linkedin.com/in/adoranwodo/',
          tw: 'https://twitter.com/adoranwodo',
          website: 'https://adoranwodo.com/',
          logo: Microsoft,
        },
        {
          photo: Tan,
          name: 'Shamane Tan',
          position: '',
          ln: 'http://www.linkedin.com/in/shamane',
          logo: Privasec,
        },
        {
          photo: Hunt,
          name: 'Will Hunt',
          position: 'Director',
          ln: 'https://www.linkedin.com/in/will-hunt/',
          tw: 'https://twitter.com/stealthsploit',
          logo: Insecurity,
        },
        {
          photo: Bodryk,
          name: 'Alex Bodryk',
          position: 'Managing director',
          ln: 'https://www.linkedin.com/in/bodryk/',
          website: 'http://cyberlands.io/',
          logo: Cyberlandsio,
        },
        {
          photo: Cholerton,
          name: 'Jessica Cholerton',
          position: 'Security Engineer',
          ln: 'https://www.linkedin.com/in/jesscholerton/',
          logo: Exabeam,
        },
        {
          photo: Khariuk,
          name: 'Sergey Khariuk',
          position: 'CTO',
          ln: 'https://www.linkedin.com/in/bodryk/',
          website: 'http://cyberlands.io/',
          logo: Cyberlandsio,
        },
        // {
        //   photo: Barthwal,
        //   name: 'Nikhil Barthwal',
        //   position: 'Sr. Software Engineer',
        //   tw: 'https://twitter.com/nikhilbarthwal',
        //   website: 'http://www.nikhilbarthwal.com',
        //   logo: facebook,
        // },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous events</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}